var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12","sm":"12"}},[_c('GMapViewer',{attrs:{"apiKey":'AIzaSyBDZQUtQQjIrF2Vus_zv5XRnFBB1-fun50',"perimeter":false,"points":_vm.item.asus.locations,"locations":[
    { id: 1, name: 'São Paulo', address: 'São Paulo, SP', lat: -23.55, lng: -46.63 },
    { id: 2, name: 'Minas Gerais', address: 'Minas Gerais', lat: -18.10, lng: -44.38 },
    { id: 3, name: 'Rio de Janeiro', address: 'Rio de Janeiro', lat: -22.90, lng: -43.20 }
  ]}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }